import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, theme } from 'antd';
import { Provider } from 'react-redux';
import './index.css';
import {
  applyTeamAssistantThemeToDocument,
  readStoredTeamAssistantThemeId,
} from './utils/teamAssistantColorThemes';
import './components/assistant/team-assistant-color-themes.css';
import App from './App';
import { store } from './redux/store';

applyTeamAssistantThemeToDocument(readStoredTeamAssistantThemeId());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            borderRadius: 2,
            // colorBgContainer: '#f3f6fe',
            // colorPrimary: '#00b96b',
          },
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);
